var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "persistent": "",
      "width": "300",
      "value": _vm.value
    },
    on: {
      "input": function (v) {
        return _vm.$emit('input', v);
      }
    }
  }, [_c('v-card', {
    staticClass: "relative"
  }, [_c('v-card-title', [_vm._v("Print options")]), _c('v-card-subtitle', [_vm._v("Note that your browser / printer may override these options")]), _c('v-card-text', [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "label": "Include margins"
    },
    model: {
      value: _vm.margin,
      callback: function ($$v) {
        _vm.margin = $$v;
      },
      expression: "margin"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include borders"
    },
    model: {
      value: _vm.border,
      callback: function ($$v) {
        _vm.border = $$v;
      },
      expression: "border"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": !_vm.loaded,
      "loading": !_vm.loaded
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("Print")])], 1), _c('iframe', {
    ref: "print",
    staticStyle: {
      "position": "absolute",
      "border": "none",
      "width": "0",
      "height": "0",
      "margin": "0",
      "padding": "0"
    },
    attrs: {
      "src": _vm.url
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }